/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import HTTP_ERROR_RESPONSE_INTERFACE from "@Services/Interfaces/Http/Response/Error";


interface ERROR_RESPONSE_INTERFACE {
    ERROR_CODE: number;
    ERROR_MESSAGE: string;
    ERROR_DATA?: any | null;
}


interface REST_API_RESPONSE_CONTENT_INTERFACE {
    ERROR?: ERROR_RESPONSE_INTERFACE;
    DATA?: any;
}


export const REST_API_RESPONSE_CONTENT_HANDLER = async (RESPONSE: Response): Promise<REST_API_RESPONSE_CONTENT_INTERFACE> => {


    const DEFAULT_RESPONSE_CONTENT = {ERROR: {
        ERROR_CODE: 599,
        ERROR_MESSAGE: "Wystąpił nieokreślony błąd - skontaktuj się z CDOK"
    }};

    if (!RESPONSE) return DEFAULT_RESPONSE_CONTENT;


    if (RESPONSE.status === 200 || RESPONSE.status === 204) {

        let RESPONSE_CONTENT: any = await RESPONSE.text();

        if (RESPONSE.status === 200) {
            try {
                RESPONSE_CONTENT = JSON.parse(RESPONSE_CONTENT);
            } catch (e) {
                RESPONSE_CONTENT = null;
            }
        }

        return {DATA: RESPONSE_CONTENT}

    }

    else {

        let RESPONSE_MESSAGE: string = await RESPONSE.text();

        if (RESPONSE.status !== 500) {
            try {
                const RESPONSE_CONTENT: HTTP_ERROR_RESPONSE_INTERFACE = JSON.parse(RESPONSE_MESSAGE);
                RESPONSE_MESSAGE = RESPONSE_CONTENT.UserMessage;
            } catch (e) {
                // console.log(e);
                RESPONSE_MESSAGE = "Wystąpił nieokreślony błąd - skontaktuj się z CDOK";
            }
        }

        return {ERROR: {
            ERROR_CODE: RESPONSE.status, ERROR_MESSAGE: RESPONSE_MESSAGE
        }};

    }

};


export default REST_API_RESPONSE_CONTENT_HANDLER;
